import React from "react";

const getPhone = (phone, props) =>
  phone && phone !== "" ? (
    <span
      role="button"
      tabIndex={0}
      onClick={() =>
        props.handleNewSearchClick(this, "Phone", phone, { phone })
      }
      className={"url-link"}
    >
      {phone}
    </span>
  ) : null;

export const getFormattedPhone = (phone) => {
  if (!phone || phone === "") return phone;
  const cleaned = `${phone}`.replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return "";
};

export default getPhone;



// WEBPACK FOOTER //
// ./src/components/common/Phone.js